import iconAlert from '../assets/icon-alert.png';

import {
	ButtonDefault,
	Description,
	PurchaseCardContainer,
	Title,
	TextGradient,
	TagTopGradient,
	BorderGradientWrapper,
	ExtraContent,
	CollapseContent,
} from './PurchaseCard-2025-1.style';
import { useEffect, useState } from 'react';
import Api from '../../../../../Services/Api';
import { trackPromise } from 'react-promise-tracker';
import Swal from 'sweetalert2';
import { useSearchParams } from 'react-router-dom';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import DefaultButton from '../../../../../Components/Buttons/DefaultButton';
import { Collapse, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useStylesPurchaseCard } from './PurchaseCard';
import iconArrowDown from '../assets/icon-arrow-down.png';
import iconMegafone from '../assets/icon-mega-fone.png';
import iconPreInscricao from '../assets/icon-pre-inscricao.svg';

export default function PurchaseCard20251WaitingList({ turma, agroupment, type, subtitle, description }) {
	const classes = useStylesPurchaseCard();
	const theme = useTheme();
	const [waitListVisibility, setWaitListVisibility] = useState('hidden');
	const [searchParams] = useSearchParams();
	const [preInscricao, setPreInscricao] = useState({
		agrupamento: agroupment,
		nome: '',
		email: '',
		telefone: '',
		utm_source: '',
		utm_medium: '',
		utm_campaign: '',
	});
	const [isHidden, setIsHidden] = useState(true);

	const matchesMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const matchesTablet = useMediaQuery(theme.breakpoints.down('md'));

	useEffect(() => {
		setPreInscricao({
			...preInscricao,
			utm_source: searchParams.get('utm_source'),
			utm_medium: searchParams.get('utm_medium'),
			utm_campaign: searchParams.get('utm_campaign'),
			utm_content: searchParams.get('utm_content'),
			utm_term: searchParams.get('utm_term'),
		});
	}, [turma]);

	useEffect(() => {
		if (turma) {
			setPreInscricao({
				agrupamento: agroupment,
				nome: '',
				email: '',
				telefone: '',
				utm_source: '',
				utm_medium: '',
				utm_campaign: '',
			});
		}
	}, [turma]);

	let sendPreInscricao = function () {
		if (!preInscricao.nome) {
			alert('Ops... Por favor informe seu nome');
			return;
		}
		if (!preInscricao.email || !preInscricao.email.includes('@') || !preInscricao.email.includes('.')) {
			alert('Ops... Por favor preencha seu email');
			return;
		}
		if (!preInscricao.telefone || preInscricao.telefone.length < 11) {
			alert('Ops... Por favor preencha seu telefone');
			return;
		}

		trackPromise(
			Api.post('PreInscricao', preInscricao).then((res) => {
				if (res) {
					Swal.fire({
						title: 'Massa! ',
						text: 'Avisaremos assim que novas turmas estiverem liberadas.',
						icon: 'success',
						confirmButtonText: 'Fechar',
						allowOutsideClick: false,
						allowEscapeKey: false,
					}).then((result) => {
						if (result.isConfirmed) {
							document.location.href = '/';
						}
					});
				}
			})
		);
	};

	const handleCloseWaitList = () => {
		setWaitListVisibility('hidden');
	};

	const handleOpenWaitList = () => {
		setWaitListVisibility('unset');
	};

	const phoneMask = (value) => {
		if (!value) return '';
		value = value.replace(/\D/g, '');
		value = value.replace(/(\d{2})(\d)/, '($1) $2');
		value = value.replace(/(\d)(\d{4})$/, '$1-$2');
		return value;
	};

	const handlePhone = (event) => {
		let input = event.target;
		input.value = phoneMask(input.value);
		setPreInscricao({
			...preInscricao,
			telefone: input.value,
		});
	};

	return (
		<Grid
			container
			flexDirection="column"
			alignItems="center"
			justifyContent="space-between"
			gap={2}
		>
			<PurchaseCardContainer style={{ justifyContent: 'start' }}>
				{/*<BorderGradientWrapper>*/}
				{/*	<TagTopGradient>*/}
				{/*		<TextGradient*/}
				{/*			style={{*/}
				{/*				fontWeight: 700,*/}
				{/*				lineHeight: '32px',*/}
				{/*				fontSize: '32px',*/}
				{/*				textTransform: 'uppercase',*/}
				{/*				fontFamily: 'Bebas Neue',*/}
				{/*			}}*/}
				{/*			className={'gradient-text'}*/}
				{/*		>*/}
				{/*			Oportunidade única!**/}
				{/*		</TextGradient>*/}
				{/*		<p style={{ lineHeight: '16px', fontSize: '18px' }}>Aluno Hardwork não para de estudar!</p>*/}
				{/*	</TagTopGradient>*/}
				{/*</BorderGradientWrapper>*/}

				<div style={{ paddingTop: '24px' }}>
					<Title style={{ fontSize: 32, lineHeight: '32px', fontWeight: 400, color: '#C9C9C9' }}>
						Arena Hardwork
					</Title>
					<TextGradient
						style={{ fontSize: 54, lineHeight: '54px', fontWeight: 800 }}
						className={'gradient-text'}
					>
						{type}
					</TextGradient>
					{/* <Title style={{ color: '#E6E6E6' }}>{subtitle}</Title> */}
				</div>
				<div style={{ height: '300px', display: 'flex', flexDirection: 'column', justifyContent: 'start' }}>
					<Description>{description}</Description>
				</div>
				<div style={{ width: '100%' }}>
					<ButtonDefault
						onClick={() => handleOpenWaitList()}
						style={{ backgroundColor: '#00AD58', fontSize: matchesMobile ? '12px' : '16px' }}
					>
						<img
							src={iconPreInscricao}
							alt={'Ícone de pré-inscrição'}
						/>
						Cadastre-se na lista de espera
					</ButtonDefault>
				</div>
				<div style={{ width: '100%' }}>
					<form
						className="form-control"
						action="javascript:;"
					>
						<Grid
							item
							container
							justifyContent={'center'}
							className={classes.containerWaitList}
							rowGap={1}
							style={{ visibility: waitListVisibility }}
						>
							<Grid
								item
								container
								justifyContent="space-between"
							>
								<Typography
									color="primary"
									className={`${classes.textWaitList} poppins`}
								>
									Inscrever-se na Lista de Espera
								</Typography>
								<CancelRoundedIcon
									onClick={() => handleCloseWaitList()}
									className={classes.cancelIcon}
								/>
							</Grid>
							<Grid
								item
								xs={12}
								md={6}
								container
								justifyContent={matchesTablet ? 'center' : 'flex-start'}
							>
								<TextField
									fullWidth
									type="string"
									name="nome"
									placeholder="Seu nome completo"
									required={true}
									InputProps={{
										className: `${classes.form} ${classes.formHeight}`,
									}}
									InputLabelProps={{
										shrink: true,
									}}
									style={matchesTablet ? { width: '100%' } : { width: '97%' }}
									onChange={(e) =>
										setPreInscricao({
											...preInscricao,
											nome: e.target.value,
										})
									}
								/>
							</Grid>
							<Grid
								item
								xs={12}
								md={6}
								container
								justifyContent={matchesTablet ? 'center' : 'flex-end'}
							>
								<TextField
									fullWidth
									type="tel"
									name="telefone"
									placeholder="Seu celular com DDD"
									required={true}
									pattern="[0-9]*"
									inputProps={{
										maxLength: 15,
									}}
									InputProps={{
										className: `${classes.form} ${classes.formHeight}`,
									}}
									InputLabelProps={{
										shrink: true,
									}}
									style={matchesTablet ? { width: '100%' } : { width: '97%' }}
									onChange={(e) => handlePhone(e)}
								/>
							</Grid>
							<Grid
								item
								xs={12}
								container
								justifyContent={matchesMobile ? 'center' : 'flex-start'}
							>
								<TextField
									fullWidth
									type="email"
									name="email"
									placeholder="Seu melhor e-mail"
									required={true}
									InputProps={{
										className: `${classes.form} ${classes.formHeight}`,
									}}
									InputLabelProps={{
										shrink: true,
									}}
									style={{ width: '100%' }}
									onChange={(e) =>
										setPreInscricao({
											...preInscricao,
											email: e.target.value,
										})
									}
								/>
							</Grid>
							<Grid
								item
								xs={12}
								md={10}
								lg={8}
								container
								className="residencia"
								style={{ height: 50, padding: '4px 0px' }}
							>
								<DefaultButton
									// type="submit"
									variant="outlined"
									color="secondary"
									className={`${classes.btnWaitList} btn`}
									onClick={() => sendPreInscricao()}
								>
									<img
										src={require('../../../../../Assets/Arena/icon-waitList.svg').default}
										alt=""
										style={{ width: 20 }}
									/>{' '}
									&nbsp; Confirmar inscrição
								</DefaultButton>
							</Grid>
						</Grid>
					</form>
				</div>
			</PurchaseCardContainer>
			<ExtraContent
				onClick={() => setIsHidden(!isHidden)}
				style={{ backgroundColor: '#262626' }}
			>
				<CollapseContent style={{ fontFamily: 'Poppins' }}>
					<div style={{ display: 'flex', gap: '8px' }}>
						<img
							src={iconMegafone}
							alt={'Ícone de megafone'}
							width={16}
							height={16}
						/>
						<Title
							style={{
								textTransform: 'uppercase',
								fontWeight: 700,
								fontSize: 14,
								textAlign: 'center',
								lineHeight: '16px',
								padding: 0,
								color: '#E6E6E6',
								fontFamily: 'Poppins',
							}}
						>
							Como funciona a lista de espera do online?
						</Title>
					</div>
					<img
						src={iconArrowDown}
						alt={'Ícone de seta para baixo'}
						width={16}
						height={16}
						style={{ transform: isHidden ? 'rotate(0deg)' : 'rotate(180deg)' }}
					/>
				</CollapseContent>
				<Collapse in={!isHidden}>
					<div style={{ paddingTop: '12px' }}>
						<Title style={{ color: '#B3B3B3' }}>
							Cadastre-se na lista de espera para ser avisado por e-mail momentos antes da abertura das
							inscrições.
						</Title>
					</div>
				</Collapse>
			</ExtraContent>
		</Grid>
	);
}
